import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/hyperlink-cell.scss';

Component('tr-grid-hyperlink-cell', {
  mixins: [baseMixin],

  properties: {
    value: {
      type: Array,
      default: [],
      observer(value) {
        if (!value || value.length === 0) this.removeAttribute('value');
      },
    },
  },

  connected() {
    this.listenTo(this, 'click', ({ target }) => {
      if (closest(target, '.placeholder, .link-edit', this)) {
        this.beginEditing();
      }
    });
  },

  preventClickEvent({ target }) {
    return this.contains(target) && ((
      this.editable && closest(target, '.placeholder, .link-edit', this)
    ) || closest(target, 'a.selected-text', this));
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    if (!this.editor) return;

    this.editing = true;
    this.listenTo(this.editor, {
      'tao:submit': this.handleValueChange.bind(this),
      'tao:closed': () => { this.editing = false; },
    }, { once: true });
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      this.editor = await this.editorLoader.editor;
      if (!this.editor) {
        resolve();
        return;
      }

      this.editor.values = this.value;
      this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
      document.body.appendChild(this.editor);
    });
  },

  renderLinks(links) {
    const result = links.map(({ name, link }) => `
      <a href="${link}" target="_blank" class="selected-text">
        ${name || link}
      </a>
    `).join('<span class="divider"></span>');

    this.querySelector('.selected-list').innerHTML = result;
  },

  handleValueChange(event) {
    const value = event.detail.values.map((v) => {
      if (v.link) {
        return { name: v.name || v.link, link: v.link };
      }
      return null;
    }).filter(v => !!v);

    this.editing = false;
    this.value = value;
    this.renderLinks(value);

    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },
});
